<template>
  <div id="app">
    <router-view />
    <ai-chat ref="aiChat"></ai-chat>
  </div>
</template>

<script>
import AiChat from "@/views/AiChat/index.vue";
export default {
  name: "App",
  components: {
    AiChat,
  },
  computed: {
    isWakeUp() {
      return this.$store.state.aiChat.isWakeUp;
    },
  },
  mounted() {
    window.addEventListener("resize", this.setRem);
  },
  methods: {
    setRem() {
      const docEl = document.documentElement;
      docEl.style.fontSize = docEl.clientWidth * 16 / 1920 + "px";
    },
    toggleShowAI() {
      if (this.isWakeUp) {
        this.$refs.aiChat.closeAi();
      } else {
        this.$refs.aiChat.start();
      }
    },
  },
};
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-right: 0 !important;
  // overflow: hidden;
  // div {
  //   font-size: 12px;
  // }
  // span {
  //   font-size: 12px;
  // }
  color: #fff;
  font-size: calc(100vw * 16 / 1920);
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>
<style lang="less" scoped>
#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  color: black;
  background-color: #fff;
  position: relative;
}
</style>
